import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo-section" }
const _hoisted_2 = { class: "logo-wrapper" }
const _hoisted_3 = { class: "logo-background" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_6 = { class: "navigation-menu" }
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_9 = {
  key: 0,
  class: "section-divider"
}
const _hoisted_10 = ["data-tooltip"]
const _hoisted_11 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_12 = ["data-tooltip"]
const _hoisted_13 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_14 = {
  key: 1,
  class: "section-divider"
}
const _hoisted_15 = ["data-tooltip"]
const _hoisted_16 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_17 = ["data-tooltip"]
const _hoisted_18 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_19 = ["data-tooltip"]
const _hoisted_20 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_21 = ["data-tooltip"]
const _hoisted_22 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_23 = {
  key: 2,
  class: "section-divider"
}
const _hoisted_24 = ["data-tooltip"]
const _hoisted_25 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_26 = ["data-tooltip"]
const _hoisted_27 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_28 = {
  key: 3,
  class: "section-divider"
}
const _hoisted_29 = ["data-tooltip"]
const _hoisted_30 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_31 = { class: "topbar-content" }
const _hoisted_32 = { class: "user-avatar" }
const _hoisted_33 = { class: "user-dropdown" }
const _hoisted_34 = { class: "dropdown-icon-wrapper" }
const _hoisted_35 = { class: "content-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_layout_grid = _resolveComponent("icon-layout-grid")!
  const _component_icon_clipboard_text = _resolveComponent("icon-clipboard-text")!
  const _component_icon_tag = _resolveComponent("icon-tag")!
  const _component_icon_home = _resolveComponent("icon-home")!
  const _component_icon_folder = _resolveComponent("icon-folder")!
  const _component_icon_trash = _resolveComponent("icon-trash")!
  const _component_icon_folder_minus = _resolveComponent("icon-folder-minus")!
  const _component_icon_settings = _resolveComponent("icon-settings")!
  const _component_icon_launch = _resolveComponent("icon-launch")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_icon_horizontal_dots = _resolveComponent("icon-horizontal-dots")!
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_icon_chevron_down = _resolveComponent("icon-chevron-down")!
  const _component_icon_logout = _resolveComponent("icon-logout")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "inspire",
    class: "modern-app"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.subMenu,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.subMenu) = $event)),
        rail: _ctx.rail,
        permanent: true,
        temporary: false,
        "mobile-breakpoint": 0,
        class: "modern-sidebar",
        elevation: "0",
        width: _ctx.rail ? 70 : 240,
        absolute: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["logo-container", { 'rail-mode': _ctx.rail }])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: require('@/assets/logo.png'),
                    alt: "Logo",
                    class: "logo-image"
                  }, null, 8, _hoisted_4),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "logo-glow" }, null, -1))
                ])
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[14] || (_cache[14] = [
                    _createElementVNode("h2", { class: "logo-title" }, "AMS", -1),
                    _createElementVNode("p", { class: "logo-subtitle" }, "Asset Management System", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/Dashboard'))),
              "data-tooltip": _ctx.rail ? 'Dashboard' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-dark", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_layout_grid, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Dashboard"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_7),
            (!_ctx.rail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[15] || (_cache[15] = [
                  _createElementVNode("span", { class: "section-label" }, "Articles", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('/Articles-receptionner'))),
              "data-tooltip": _ctx.rail ? 'Articles réceptionnés' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_clipboard_text, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Nouveaux Articles"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_10),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/Articles'))),
              "data-tooltip": _ctx.rail ? 'Articles affectés' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-light", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_tag, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Articles affectés"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_12),
            (!_ctx.rail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[16] || (_cache[16] = [
                  _createElementVNode("span", { class: "section-label" }, "Inventaire", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/Inventaire-Location'))),
              "data-tooltip": _ctx.rail ? 'Inventaire par site' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-dark", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_home, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Par site"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_15),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/Inventaire-zone'))),
              "data-tooltip": _ctx.rail ? 'Inventaire par zone' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_folder, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Par zone"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_17),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/Inventaire-emplacement'))),
              "data-tooltip": _ctx.rail ? 'Inventaire par emplacement' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-light", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_folder, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Par emplacement"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_19),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/inventaire-departement'))),
              "data-tooltip": _ctx.rail ? 'Inventaire par département' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-dark", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_folder, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Par département"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_21),
            (!_ctx.rail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[17] || (_cache[17] = [
                  _createElementVNode("span", { class: "section-label" }, "Gestion", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateTo('/Article_consomme'))),
              "data-tooltip": _ctx.rail ? 'Articles consommés' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper neutral-gray", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_trash, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Articles consommés"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_24),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { 'rail-item': _ctx.rail }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigateTo('/Article_archive'))),
              "data-tooltip": _ctx.rail ? 'Articles reformés' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_folder_minus, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Articles reformés"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_26),
            (!_ctx.rail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[18] || (_cache[18] = [
                  _createElementVNode("span", { class: "section-label" }, "Configuration", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item external", { 'rail-item': _ctx.rail }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openExternal('https://invtfm5.ma/admin/'))),
              "data-tooltip": _ctx.rail ? 'Paramétrage' : ''
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-icon-wrapper primary-gold-dark", { 'rail-icon': _ctx.rail }])
              }, [
                _createVNode(_component_icon_settings, { class: "nav-icon" })
              ], 2),
              (!_ctx.rail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createTextVNode(" Paramétrage ", -1)),
                    _createVNode(_component_icon_launch, { class: "external-icon" })
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_29)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "rail", "width"]),
      _createVNode(_component_v_app_bar, {
        "scroll-threshold": "0",
        class: _normalizeClass(["modern-topbar", { 'rail-topbar': _ctx.rail }]),
        elevation: "0",
        height: "72"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.rail = !_ctx.rail), ["stop"])),
              class: "menu-toggle"
            }, [
              _createVNode(_component_icon_horizontal_dots, { class: "toggle-icon" })
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title-section" }, [
              _createElementVNode("h1", { class: "app-title" }, "Système de Gestion d'Immobilisations"),
              _createElementVNode("p", { class: "app-subtitle" }, "Plateforme de gestion moderne")
            ], -1)),
            _createVNode(_component_v_menu, { "open-on-hover": "" }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("div", _mergeProps(props, { class: "user-profile" }), [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_icon_user, { class: "avatar-icon" })
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "user-info" }, [
                    _createElementVNode("span", { class: "user-name" }, "Administrateur"),
                    _createElementVNode("span", { class: "user-role" }, "Super Admin")
                  ], -1)),
                  _createVNode(_component_icon_chevron_down, { class: "dropdown-icon" })
                ], 16)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "dropdown-item",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_icon_logout, { class: "dropdown-icon-svg" })
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "dropdown-label" }, "Déconnexion", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_main, {
        class: _normalizeClass(["bg-gray-50 main-content p-5 m-5", { 'rail-content': _ctx.rail }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_footer, {
        class: _normalizeClass(["modern-footer bg-white border-t border-gray-200 shadow-inner", { 'rail-footer': _ctx.rail }])
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [
          _createElementVNode("div", { class: "w-full flex justify-center items-center py-3" }, [
            _createElementVNode("span", { class: "text-gray-600 text-sm font-medium text-center" }, "© 2024 SM@TCH - Système de Gestion d'Immobilisations")
          ], -1)
        ])),
        _: 1,
        __: [23]
      }, 8, ["class"])
    ]),
    _: 1
  }))
}